var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288-384q-39.6 0-67.8-28.2Q192-440.4 192-480q0-39.6 28.2-67.8Q248.4-576 288-576q39.6 0 67.8 28.2Q384-519.6 384-480q0 39.6-28.2 67.8Q327.6-384 288-384Zm0 144q-100 0-170-70T48-480q0-100 70-170t170-70q65 0 120 32.5t88 87.5h329.14q7.86 0 14.36 3 6.5 3 11.5 8l83 83q5 5 7.5 12t2.5 14.2q0 7.2-3 13.5t-8 11.3L802.15-331.85Q797-327 791-325t-12 3q-6 1-12-1t-11-6l-60-43-50 42q-4.83 4-10.62 6-5.79 2-11.59 2-5.79 0-11.79-1.5-6-1.5-11-5.5l-73-55h-20q-24 68-85.5 106T288-240Zm0-72q63.15 0 111.07-40.5Q447-393 454-456h98l70 52 71-59 81 58 82-76-46-47H449q-19-53-62.5-86.5T288-648q-70 0-119 49t-49 119q0 70 49 119t119 49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.c6c5489c43ae6f0fcc1843b1060e7b4d.svg";
export { ForwardRef as ReactComponent };